export enum NavOverFlowWrapperAction {
    NAV_OVERFLOW_MENU = 'NAV_OVERFLOW_MENU',
    NO_ACTION = 'NO_ACTION',
}
